{
    angular.module('interfaceModule')
        .controller('QrpayModalController',QrpayModalController);
    QrpayModalController.$inject = ['$scope',"$state",'$stateParams','request.order',
    '$timeout'];
    function QrpayModalController($scope,$state,$stateParams,orderRequest,
        $timeout) {
        let vm=this;
        $scope.vm=vm;
        let collect={
            'activate':activate,
            'close':close,
            'checkPayResult':checkPayResult,
            'hasPaid':false,
            'timer':null,
            'checkInterval':1000,//每次检测支付结果的间隔
            //新加的
            'recharge':false,
            'pay':false,
            'paiddate':null

        };
        vm.collect=collect;
        activate();

        function activate(){
            // console.log('QrpayModalController',$scope.qrcode);
            $scope.$on("$destroy", function(e) {
                // console.log("QrpayModal:$destroy",$scope==e.targetScope);
                // if($scope==e.targetScope){
                    //$scope.$close();
                    $timeout.cancel(collect.timer);

                // }
                
            })
            //判断是支付还是充值：
            if($scope.orderInfo){
                collect.pay = true;
                collect.recharge = false;
            }
            if($scope.rechargeMomey){
                collect.pay = false;
                collect.recharge = true;
            }
            checkPayResult();
        }

        // function close(){
        //     $scope.$close();
        // }
        function checkPayResult(){
            //请求成功会返回微信或支付宝支付结果resData， 然后设置是否已支付参数hasPaid
            console.log('进入检查支付结果');
            orderRequest.checkPayResult($scope.payMethod,$scope.orderInfo.orderId)
            .then(function (resData){
                console.log('检查支付结果一次回来');
                var price;
                if($scope.payMethod==0){
                    collect.hasPaid=resData.trade_status=="TRADE_SUCCESS";
                    collect.paiddate=resData.send_pay_date;
                    price=resData.total_amount;//第三方得到的支付金额
                }else if($scope.payMethod==1){
                    collect.hasPaid=resData.trade_state=="SUCCESS";
                    collect.paiddate=resData.time_end;
                    price=(resData.total_fee)*1/100;//第三方得到的支付金额
                }

                if(collect.hasPaid){
                    console.log('扫码支付成功后第三方传回来的信息：',resData)
                    console.log('订单信息：',$scope.orderInfo);

                    if($scope.orderInfo.payAction == 1){
                        //如果订单已支付，调用订单状态设置函数，讲订单设置为已支付。
                        orderRequest.setOrderPaid($scope.orderInfo.orderPrintId,$scope.orderInfo.amount,$scope.payMethod,collect.paiddate);
                        collect.timer=$timeout(function(){
                            $scope.$close();
                            //支付成功之后就跳转到 paySuccess 页面；并且把订单ID也传过去
                            $state.go('main.paySuccess',{'orderId':$scope.orderInfo.orderId});
                        },collect.checkInterval);

                    }else if($scope.orderInfo.payAction == 0){
                        //设置充值订单信息：用户账号， 充值金额，充值平台，充值单号，交易类型，赠送比例
                        orderRequest.setRechargeInfo($scope.orderInfo.userId,$scope.orderInfo.amount,$scope.payMethod,$scope.orderInfo.orderId,$scope.orderInfo.payAction);
                        collect.timer=$timeout(function(){
                            $scope.$close();
                            //支付成功之后就跳转到 order 页面；
                            $state.go('main.user',{},{reload:true});
                        },collect.checkInterval);
                    }


                }else{
                    collect.timer=$timeout(checkPayResult,collect.checkInterval);
                }
            });
        }
    }
    
}